import { FormikValues, useFormikContext } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import SignatureCanvas from 'react-signature-canvas';

import { base64ParaArquivo } from 'View/functions';

import { Grupo, Rotulo } from '.';
import Ajuda from './Ajuda';

interface Props {
    ajuda?: string;
    name: string;
    rotulo?: string;
    semMargem?: boolean;
}

const Assinatura = (props: Props): React.ReactElement =>
{
    const ref = useRef<ReactSignatureCanvas>(null);
    const [ base64, setBase64 ] = useState<string>('');
    const { ajuda, name, rotulo } = props;
    const { errors, touched, setFieldValue } = useFormikContext<FormikValues>();

    useEffect(() => {
        if (ref.current && ref.current.getCanvas().parentElement) {
            ref.current.fromDataURL(base64);
            ref.current.getCanvas().width = ref.current.getCanvas().parentElement?.offsetWidth || 200;
            ref.current.getCanvas().height = 200;
            ref.current.clear();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ ref ]);

    useEffect(() => {
        if (base64) {
            const arquivo = base64ParaArquivo(base64, 'arquivo');
            setFieldValue(name, arquivo, true);
        }
    }, [base64, name, setFieldValue]);

    return (
        <Grupo semMargem={ props.semMargem } emLinha={ false }>
            <SignatureCanvas
                ref={ ref }
                penColor="#3F90AB"
                backgroundColor="white"
                canvasProps={{
                    className: `rounded border w-100 ${ errors[name] && touched[name] && 'border-danger' }`,
                }}
                onEnd={ () => setBase64(ref.current?.toDataURL('image/jpeg') || '') }
            />
            <React.Fragment>
                { rotulo && (
                    <Rotulo name={ name }>
                        { rotulo }
                    </Rotulo>
                ) }
            </React.Fragment>
            <React.Fragment>
                { ajuda && (
                    <Ajuda>{ ajuda }</Ajuda>
                ) }
            </React.Fragment>
            <div className="invalid-tooltip">
                { errors[name] && touched[name] && errors[name] }
            </div>
        </Grupo>
    );
}

export default Assinatura;
